import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'app-overlay',
    imports: [CommonModule],
    templateUrl: './overlay.component.html',
    styleUrl: './overlay.component.css'
})
export class OverlayComponent {

  constructor() { }

}
